/** Node card size in world units; ports and marquee hit-testing depend on it. */
export const NODE_WIDTH = 260
export const NODE_HEIGHT = 130

/** The canvas is a large fixed world; node coordinates are relative to its centre. */
export const WORLD_SIZE = 40000
export const WORLD_ORIGIN = WORLD_SIZE / 2

/** Vertical position of a condition node's true/else outputs, as a fraction of height. */
export const CONDITIONAL_TOP_RATIO = 0.36
export const CONDITIONAL_BOTTOM_RATIO = 0.64

export const DEFAULT_VIEWPORT = {
  x: -WORLD_ORIGIN + 280,
  y: -WORLD_ORIGIN + 180,
  scale: 1,
}

export const MIN_ZOOM = 0.05
export const MAX_ZOOM = 2.5

/** Placeholder groups shown until the deck's real groups have loaded. */
export const PLACEHOLDER_GROUPS = [
  { id: 'group-0', title: 'Ungrouped' },
  { id: 'group-10', title: 'Group A' },
  { id: 'group-11', title: 'Group B' },
  { id: 'group-12', title: 'Group C' },
]

export const TEMPLATE_STORAGE_KEY = 'perlingo.flow-templates.global'

/** Prefix that marks flow-editor content in the system clipboard. */
export const CLIPBOARD_MARKER = 'PERLINGO_FLOW_CLIPBOARD:'
